import Box from "@mui/material/Box";
import QueueOrdersReport from "./components/queueOrdersReport/queueOrdersReport";
import Queue from "../../../../models/queue/queue";

export default function AdminView({
  queue,
}: {
  queue: Queue | null | undefined;
}) {
  return (
    <Box>
        <QueueOrdersReport queueId={queue?.queueId} />
    </Box>
  );
}
